import styled from 'styled-components';
import { variables } from 'variables';

export const ChangelogSC = styled.div`
  padding: ${variables.pageContentPadding}px;
  background: ${(props) => props.theme.pageBackgroundColor};
  padding-right: 25px;
  width: 100%;
  min-height: calc(100vh - ${variables.headerHeight + variables.pageContentPadding * 2}px);
`;
export const Changelog = styled.div`
  display: flex;
  @media only screen and (max-width: 900px) {
    flex-direction: column;
  }
`;
export const MobileChangelog = styled.div`
  display: flex;
  @media only screen and (max-width: 900px) {
    flex-direction: column;
  }
`;
export const ChangelogMobile = styled.div`
  display: flex;
`;
export const Div1 = styled.div`
  width: 22em;
  @media only screen and (max-width: 900px) {
    margin-bottom: 20px;
  }
`;
export const Div3 = styled.div`
  width: 100%;
  @media only screen and (max-width: 900px) {
    margin-bottom: 30px;
  }
`;

export const VersionSC = styled.div`
  background-color: ${(props) => props.theme.primaryDarkColor};
  padding: 15px 20px;
  border-radius: 5px;
  position: relative;
  @media only screen and (min-width: 900px) {
    &:after {
      content: '';
      width: 0;
      height: 0;
      border-top: 10px solid transparent;
      border-bottom: 10px solid transparent;
      border-left: 10px solid ${(props) => props.theme.primaryDarkColor};
      position: absolute;
      top: 20px;
      right: -9px;
    }
  }
  @media only screen and (max-width: 900px) {
    margin-left: 35px;
    &:before {
      content: '';
      width: 0;
      height: 0;
      border-top: 10px solid transparent;
      border-bottom: 10px solid transparent;
      border-right: 10px solid ${(props) => props.theme.primaryDarkColor};
      position: absolute;
      top: 20px;
      left: -10px;
    }
  }
`;

export const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: white;
`;

export const VersionName = styled.div`
  padding-bottom: 5px;
  h5 {
    font-weight: 550;
    margin: 0;
  }
`;

export const VersionDate = styled.div`
  h6 {
    margin: 0;
  }
`;

export const Line = styled.div`
  position: relative;
  margin-left: 35px;
  width: 2px;
  min-height: 100%;
  background: #bfbfbf;
  color: #ff7300;

  i {
    position: absolute;
    font-size: 18px;
    font-weight: 700;
    top: 21px;
    right: -13px;
  }
  @media only screen and (max-width: 900px) {
    margin-left: 20px;
  }
`;

export const DetailSC = styled.div`
  background: ${(props) => props.theme.lightShadeBackgroundColor};
  padding: 15px 20px;
  padding-top: 0;
  margin-left: 35px;
  margin-bottom: 30px;
  border-radius: 5px;
  position: relative;
  &:before {
    content: '';
    width: 0;
    height: 0;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    border-right: 10px solid #f1f1f1;
    position: absolute;
    top: 20px;
    left: -10px;
  }
`;

export const DetailFlex = styled.div`
  display: flex;
  flex-direction: column;
  color: black;
`;
export const DetailName = styled.div`
  padding-bottom: 10px;
  h6 {
    margin: 0;
    margin-top: 15px;
    font-weight: 550;
  }
`;
export const Circle = styled.div`
  margin-right: 8px;
  i {
    font-size: 10px;
  }
`;
export const DetailText = styled.div`
  display: flex;
  margin-bottom: 15px;
  p {
    line-height: 20px;
    color: black;
  }
`;
